import { CallerAuthentication } from '../models/caller-authentication-state.model';

export class SetCallerAuthentication {
  static readonly type = '[CallerAuthentication] Set caller authentication';

  constructor(public payload: CallerAuthentication) {
  }
}
